import { render, staticRenderFns } from "./Moderation_list_editor.vue?vue&type=template&id=095dc8de"
import script from "./Moderation_list_editor.vue?vue&type=script&lang=js"
export * from "./Moderation_list_editor.vue?vue&type=script&lang=js"
import style0 from "./Moderation_list_editor.vue?vue&type=style&index=0&id=095dc8de&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports